export const GET_ASSESSMENT_LEVEL_LIST = 'building/assessment_level/get_list';
export const SHOW_DATA = 'building/assessment_level/show_data';
export const CREATE_DATA = 'building/assessment_level/create_data';
export const UPDATE_DATA = 'building/assessment_level/update_data';
export const REMOVE_DATA = 'building/assessment_level/remove_data';
export const GET_LAND_CLASSIFICATIONS = '/land/get_land_classifications';
export const GET_ORDINANCE_REVISION_LIST = '/get_ordinance_revision_list';